export const lOGIN_API = "login";
export const LOGOUT_API = "logout"; // Add logout endpoint
export const ME_API = "user/me";

export const COMPANY = "companies";

export const MEMBER = "member";
export const MEMBER_LIST = "members";
export const CHECK_REAL_FACE = "checkrealface";
export const MEMBER_RESEND_LINK = "resend-verification-email"
export const CHECK_TOKEN_VALIDITY = "check-token-validity"

export const CHECK_UPDATED_EMAIL_AVAILABILITY = "check-email-availability";
export const VERIFY_OTP = "verify-otp";
export const SEND_OTP = "send-otp";

export const CHANGE_PASSWORD = "change-password";
export const CHANGE_PASSWORD_COMPANY = "change-password-company";
export const RESET_PASSWORD = "user/reset-password";
export const FORGOT_PASSWORD = "user/forgot-password";

export const COUNTRIES = "countries";
export const STATES = "states/";
export const CITIES = "cities/";

export const VERIFICATION_ATTEMPTS = "admin/verification-attempts";
// Company-scoped verification attempts (plan-gateable canonical endpoint).
// Use this from company-facing pages; the admin variant above is platform-wide.
export const COMPANY_VERIFICATION_ATTEMPTS = "verification-attempts";

// Admin Analytics Endpoints
export const ADMIN_ANALYTICS_REALTIME_STATS = "admin/analytics/realtime_statistics";
export const ADMIN_ANALYTICS_MANUAL_REVIEW_LOGS = "admin/analytics/manual_review_logs";
export const ADMIN_ANALYTICS_EXPORT_REPORT = "admin/analytics/export_report";
export const ADMIN_ANALYTICS_VERIFICATION_QUALITY = "admin/analytics/verification_quality_metrics";
export const ADMIN_ANALYTICS_TIME_BASED = "admin/analytics/time_based_analytics";
export const ADMIN_ANALYTICS_COMPANY_PERFORMANCE = "admin/analytics/company_performance_comparison";
export const ADMIN_ANALYTICS_USER_JOURNEY = "admin/analytics/user_journey_analytics";
export const ADMIN_ANALYTICS_DASHBOARD = "admin/analytics/dashboard";

// Company Analytics Endpoints
export const COMPANY_ANALYTICS_REALTIME_STATS = "company/analytics/realtime_statistics";
export const COMPANY_ANALYTICS_MANUAL_REVIEW_LOGS = "company/analytics/manual_review_logs";
export const COMPANY_ANALYTICS_EXPORT_REPORT = "company/analytics/export_report";
export const COMPANY_ANALYTICS_VERIFICATION_QUALITY = "company/analytics/verification_quality_metrics";
export const COMPANY_ANALYTICS_TIME_BASED = "company/analytics/time_based_analytics";
export const COMPANY_ANALYTICS_USER_JOURNEY = "company/analytics/user_journey_analytics";

// Legacy endpoints (for backward compatibility)
export const ANALYTICS_REALTIME_STATS = "admin/analytics/realtime_statistics";
export const ANALYTICS_MANUAL_REVIEW_LOGS = "admin/analytics/manual_review_logs";
export const ANALYTICS_EXPORT_REPORT = "admin/analytics/export_report";

export const QUALITY_SETTINGS = "api/settings/quality_settings/";

// Verification Rules (admin-managed). The company-facing company/verification-rules
// endpoints were removed; companies use plan-gated company/tier-settings instead.
export const ADMIN_VERIFICATION_RULES_GET = "admin/verification-rules";
export const ADMIN_VERIFICATION_RULES_PUT = "admin/verification-rules";

export const COMPANIES_WITH_MEMBERS = 'verification/companies-with-members';

// OTP Fallback Endpoints
export const REQUEST_OTP_FALLBACK = 'verification/request-otp-fallback';
export const VERIFY_OTP_FALLBACK = 'verification/verify-otp-fallback';
export const RESEND_OTP_FALLBACK = 'verification/resend-otp-fallback';
export const CHECK_OTP_ELIGIBILITY = 'verification/check-otp-eligibility';

// Admin Billing Endpoints
export const ADMIN_BILLING_PRICING_TIERS = 'admin/pricing-tiers';
export const ADMIN_BILLING_COMPANY_BALANCES = 'admin/company-balances';
export const ADMIN_BILLING_TRANSACTIONS = 'admin/transactions';
export const ADMIN_BILLING_BALANCE_CHECK_LOGS = 'admin/balance-check-logs';
export const ADMIN_BILLING_MANUAL_ADJUSTMENT = 'admin/manual-balance-adjustment';
export const ADMIN_BILLABLE_ROUTES = 'admin/billable-routes';
export const ADMIN_TIER_SETTINGS = 'admin/tier-settings';
export const ADMIN_API_ACCESS_CATALOG = 'admin/api-access/catalog';
export const ADMIN_EXCHANGE_RATE = 'admin/exchange-rate';
export const ADMIN_REFUND = 'admin/refund';
export const ADMIN_TRIAL_SETTINGS = 'admin/trial-settings';
export const ADMIN_USAGE_BASED_SETTINGS = 'admin/usage-based-settings';

// Company Billing Endpoints
export const VTN_TOPUP_INITIATE = 'vtn/topup/initiate';
export const VTN_TOPUP_PAYPAL_CAPTURE = 'vtn/topup/paypal-capture';
export const VTN_TOPUP_PAYSTACK_VERIFY = 'vtn/topup/paystack-verify';
export const VTN_PAYSTACK_PUBLIC_KEY = 'vtn/paystack-public-key';
export const VTN_BALANCE = 'vtn/balance';
export const VTN_ACCOUNT_STATUS = 'vtn/account-status';
export const VTN_PRICING_TIERS = 'vtn/pricing-tiers';
export const VTN_EXCHANGE_RATE = 'vtn/exchange-rate';
export const VTN_SELECT_TIER = 'vtn/select-tier';
export const VTN_RESEND_TIER_AUTH = 'vtn/resend-tier-auth';
export const VTN_REQUEST_REAUTH = 'vtn/request-reauth';
export const VTN_REVOKE_TOKEN = 'vtn/revoke-token';
export const VTN_CANCEL_PLAN = 'vtn/cancel-plan';
export const COMPANY_BILLING_ENTITLEMENT = 'company/billing-entitlement';
export const COMPANY_BILLING_USAGE = 'company/billing/usage';
export const COMPANY_BILLING_HISTORY = 'company/billing/history';
export const COMPANY_USAGE_BASED_FALLBACK = 'company/billing/usage-based-fallback';

// Company Tier Settings
export const COMPANY_TIER_SETTINGS = 'company/tier-settings';
